import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { company, customerData } from './CustomerData'

import profileIcon from '../assets/NavBarIcons/profileIcon.png'
import hamburgerIcon from '../assets/NavBarIcons/hamburger.png'
import arrowIcon from '../assets/DashboardIcons/DashboardQAIcons/arrowIcon.png'

import '../css/NavBar.css'

export default function NavBar({ impersonationMode, setShowMobileSideBar }) {
  const navigate = useNavigate()
  const [showPopup, setShowPopup] = useState(false)
  const popupRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false)
      }
    }

    if (showPopup)
      document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showPopup])

  const togglePopup = (event) => {
    event.stopPropagation()
    setShowPopup(prev => !prev)
  }

  return (
    <>
      {impersonationMode && (
        <div className='w-full flex flex-row items-center justify-center bg-yellow-300 font-robo p-4'>
          <p className='font-bold'>Impersonating {customerData.customerLeadData.leadContact.contactName}</p>
        </div>
      )}
      <nav className='max-sm:sticky max-sm:top-0 max-sm:z-30 flex justify-between py-3 bg-nav font-robo items-center'>
        <div className='max-sm:hidden cursor-pointer w-40 logo ml-8' onClick={() => navigate('/dashboard')}>
          <img id='companyLogo' className='w-full h-full object-contain' src={company.companyLogoURL} alt='setcLogo' />
        </div>
        <img onClick={() => setShowMobileSideBar(true)} className='lg:hidden w-8 ml-4' src={hamburgerIcon} alt='setcLogo' />
        <div className='flex font-robo mr-5'>
          <div
            className='relative popup-container flex items-center bg-gray-300 p-2 rounded-md hover:cursor-pointer w-fit'
            onClick={togglePopup}
            ref={popupRef}
          >
            <img className='h-8 cursor-pointer' src={profileIcon} alt='profileIcon' />
            <p className='ml-1 mr-2'>{customerData.customerLeadData.leadContact.contactFirstName}</p>
            <img className='w-4 h-4' style={{ transform: showPopup ? 'rotate(-90deg)' : 'rotate(90deg)' }} src={arrowIcon} alt='arrowIcon' />
            <div className={`right-5 popup-content ${showPopup ? 'visible' : ''}`}>
              <button className='text-left text-black hover:bg-gray-200 w-full rounded-md p-1' onClick={() => navigate('/account')}>My Account</button>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}
